import { Directive, HostBinding,Input, ElementRef, Renderer2, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from '../../core';

@Directive({
  standalone: false,
  selector: '[currencySymbolDirective]'
})
export class CurrencySymbolDirective implements OnInit {
  @Input() valueToObserve: number;
  @HostBinding('textContent') content: string;

  private currency: string;

  constructor(private el: ElementRef, private renderer: Renderer2, private authService: AuthService) {
    this.currency = this.authService.getUser().currencyCode;

  }

  ngOnInit() {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.content = this.updateView(this.valueToObserve);
  }


  private updateView(newValue: number): string {
    if (newValue !== null && newValue !== undefined) {
      return`${this.currency}/ ${this.formatNumber(newValue)}`;
    } else {
      return `${this.currency}/ 0.00`;
    }
  }

  private formatNumber(value: number): string {
    return value.toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
